import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getList = (params) => {
  return axios.request({
    url: "/shipments/free_output/getList",
    method: "get",
    params,
  });
};

export const getFields = () => {
  return axios.request({
    url: `/shipments/free_output/fields`,
    method: "get",
  });
};

export const output = (data) => {
  return axios.request({
    url: `/shipments/free_output/output`,
    method: "post",
    data
  });
};

export const del = (id) => {
  return axios.request({
    url: `/shipments/free_output/delete/${id}`,
    method: "post",
  });
};
